import { useContext } from 'react';
import { StyledProjectsFiltersBar } from './ProjectsFiltersBar.style';
import Loader from './Loader';
import Filters from './Filters';
import ProjectsPeriodPicker from '../ProjectsPeriodPicker/ProjectsPeriodPicker';
import useFiltersBarRef from './useFiltersBarRef';

const ProjectsFiltersBar = ({
  Context,
  disabled,
  isCustomDateOutsideRange,
  hiddenPeriods = [],
  children
}) => {
  const {
    state: { period, setPeriod, isInitialized, isLoading }
  } = useContext(Context);

  const filtersBarRef = useFiltersBarRef({ Context });

  if (!isInitialized || isLoading)
    return (
      <StyledProjectsFiltersBar ref={filtersBarRef}>
        <Loader />
      </StyledProjectsFiltersBar>
    );

  return (
    <StyledProjectsFiltersBar ref={filtersBarRef} data-cy='filter-set-bar'>
      <ProjectsPeriodPicker
        period={period}
        setPeriod={setPeriod}
        disabled={disabled}
        hiddenPeriods={hiddenPeriods}
        isCustomDateOutsideRange={isCustomDateOutsideRange}
      />
      <Filters Context={Context} />
      {children}
    </StyledProjectsFiltersBar>
  );
};

export default ProjectsFiltersBar;
